'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const Formatters=require('../../../../dist-es6/client/formatters');let

PersonalScheduleController=(_class=function(_BaseController){_inherits(PersonalScheduleController,_BaseController);
function PersonalScheduleController(
$scope,
$state,
$window,
$timeout,
$modal,
personalScheduleDataService,
socketService,
breadcrumbsService,
displaySettingsService,
uiCommandFactory,
paramSyncService,
uncaughtErrorHandler){_classCallCheck(this,PersonalScheduleController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,$timeout));

_this._assignParamsToController($state.params);

_this._updateUrlParamsFromController=paramSyncService.start(_this,$scope,function(newParams){return _this._updateControllerParamsFromUrl(newParams)});

_this._$state=$state;
_this._$window=$window;
_this._$timeout=$timeout;
_this._$modal=$modal;

_this.weekFormatter=_this.weekFormatter.bind(_this);
_this.groupFormatter=_this.groupFormatter.bind(_this);

_this._socketService=socketService;
_this._breadcrumbsService=breadcrumbsService;
_this._displaySettingsService=displaySettingsService;
_this._personalScheduleDataService=personalScheduleDataService;

_this._use24HourTimeline=displaySettingsService.use24HourTimeline;

_this._fatigueThreshold=null;
_this.hideEverything=!0;
_this._isLoadingDifferentWeek=!0;

_this._planRouteCommand=uiCommandFactory.make(_this._onPlanRoute.bind(_this));
_this.openFatigueReport=function(){return _this._openFatigueReport()};

_this.graphSubViewConfiguration=_this._getGraphSubViewConfiguration();

breadcrumbsService.dropCrumb('Personal Schedule');

$scope.$watch('controller.selectedWeek',function(newSelectedWeek,oldSelectedWeek){
if(!_.exists(newSelectedWeek)){
return;
}

if(newSelectedWeek===oldSelectedWeek){
const existingQueryInterval=_.get(_this._personalStatistics,'queryInterval');
if(existingQueryInterval&&newSelectedWeek.equals(existingQueryInterval)){
return;
}
}

_this._startLoadingDataForSelectedWeek();
});

_this._startLoading();return _this;
}PersonalScheduleController.prototype.

_updateControllerParamsFromPersonInfo=function _updateControllerParamsFromPersonInfo(personInfo){
this._personId=personInfo.id;
this._employeeId=personInfo.employeeId;
this._updateUrlParamsFromController({
id:this._personId,
employeeId:this._employeeId});

};PersonalScheduleController.prototype.


_startLoading=function(){var ref=_asyncToGenerator(function*(){var _this2=this;
const response=yield this._personalScheduleDataService.tryGetPersonInfoAndWeeksInQueryInterval(
{id:this._personId,employeeId:this._employeeId},
this._queryInterval,
this._timezone);

if(_.exists(response.error)){
if(response.error==='NotFound'){
this._$state.go("fdc.features.emiratesDashboard");
}
return;
}


if(!_.exists(this._timezone)){
this._$timeout(function(){
_this2.hideEverything=!0;
_this2._$state.go('fdc.features.personalSchedule',{timezone:response.personInfo.homeTimezone});
});
return;
}


this._$timeout(function(){
if(!_.isEqual(response.personInfo,_this2._personInfo)){
_this2._updateControllerParamsFromPersonInfo(response.personInfo);
}
_this2._personInfo=response.personInfo;
_this2._availableWeeks=response.weeksInQueryInterval;
_this2._selectedWeek=_this2._availableWeeks[0];

const{firstName:firstName,lastName:lastName}=_this2._personInfo;
const newWindowTitle=`${firstName} ${lastName} (${_this2.weekFormatter(_this2._selectedWeek)})`;
_this2._breadcrumbsService.updateLabelForState(newWindowTitle,'fdc.features.personalSchedule');
});
});function _startLoading(){return ref.apply(this,arguments)}return _startLoading}();PersonalScheduleController.prototype.


_startLoadingDataForSelectedWeek=function(){var ref=_asyncToGenerator(function*(){var _this3=this;
this._isLoadingDifferentWeek=!0;

let{
weekSectionModels:weekSectionModels,
now:now,
timeOfLastScheduleUpdate:timeOfLastScheduleUpdate,
timeOfLastHosStatus:timeOfLastHosStatus,
invalidDataWarning:invalidDataWarning,
predictedWorkday:predictedWorkday,
forecastDutyInterval:forecastDutyInterval,
estimatesAsOfTime:estimatesAsOfTime,
fatigueThreshold:fatigueThreshold,
deviationThreshold:deviationThreshold,
groupMemberships:groupMemberships,
displayTimeZone:displayTimeZone}=
yield this._personalScheduleDataService.getScheduleDataFor(this._personInfo,[this._selectedWeek],this._timezone);

let{personalStatistics:personalStatistics,personalSchedule:personalSchedule,dailySchedules:dailySchedules}=weekSectionModels[0];

if(!personalStatistics.queryInterval.equals(this._selectedWeek)){

return;
}

this._$timeout(function(){
_this3._personalStatistics=personalStatistics;
_this3._personalSchedule=personalSchedule;
_this3._dailySchedules=dailySchedules;
_this3._fatigueThreshold=fatigueThreshold;
_this3._deviationThreshold=deviationThreshold;
_this3._groupMemberships=groupMemberships;
_this3._now=now,
_this3._timeOfLastScheduleUpdate=timeOfLastScheduleUpdate;
_this3._timeOfLastHosStatus=timeOfLastHosStatus;
_this3._invalidDataWarning=invalidDataWarning;
_this3._predictedWorkday=predictedWorkday;
_this3._forecastDutyInterval=forecastDutyInterval;
_this3._estimatesAsOfTime=estimatesAsOfTime;
_this3._displayTimeZone=displayTimeZone;

if(_.exists(_this3.multiView)){
_this3.multiView.reloadCurrentView();
}

_this3.hideEverything=!1;
_this3._isLoadingDifferentWeek=!1;
});
});function _startLoadingDataForSelectedWeek(){return ref.apply(this,arguments)}return _startLoadingDataForSelectedWeek}();PersonalScheduleController.prototype.

_getGraphSubViewConfiguration=function _getGraphSubViewConfiguration(){
const controllerPropertiesToBindToSubViews=[
'personInfo',
'displayTimeZone',
'timezoneDescription',
'estimatesAsOfTime',
'timezone',
'homeTimezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'deviationThreshold',
'now',
'timeOfLastScheduleUpdate',
'timeOfLastHosStatus',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'dutyFormatter',
'sleepFormatter',
'sleepPromotingFormatter',
'tripFormatter',
'personalStatistics',
'groupMemberships'];


return ControllerExtensions(this).getMultiViewConfigurationFor(controllerPropertiesToBindToSubViews,[{
label:'Schedule',
buttonClass:'day-to-day-button',
directiveName:'pulsar-raster-schedule'},
{
label:'Timeline',
buttonClass:'timeline-button',
directiveName:'pulsar-timeline-schedule'},
{

label:'Incidents',
buttonClass:'sces-button',
directiveName:'pulsar-incidents-schedule'}]);

};PersonalScheduleController.prototype.

_assignParamsToController=function _assignParamsToController(params){
this._employeeId=params.employeeId;
this._personId=params.id;
this._queryInterval=params.interval;
this._timezone=params.timezone;
};PersonalScheduleController.prototype.

_updateControllerParamsFromUrl=function _updateControllerParamsFromUrl(newStateParams){
let{id:id,interval:interval,timezone:timezone,employeeId:employeeId}=newStateParams;

if(this._personId===id&&
this._employeeId===employeeId&&
this._queryInterval&&this._queryInterval.equals(interval)&&
this._timezone===timezone){
return;
}

this._assignParamsToController(newStateParams);
this._startLoading();
};PersonalScheduleController.prototype.

_openFatigueReport=function _openFatigueReport(){
if(!_.exists(this,'personalSchedule.bounds.end')){
return;
}

const previousWeek=this.selectedWeek.shift('days',-7,this._timezone);

const url=this._$state.href('fdc.features.fatigueReport',{
id:this._personId,
interval:TimeInterval.from(previousWeek.start).to(this.selectedWeek.end),
timezone:this._timezone,
notificationType:this._displaySettingsService.stickySettings.get('selectedNotificationType')||NotificationType.AllThresholdsExceeded});


this._$window.open(url,'_blank');
};PersonalScheduleController.prototype.

onPlanRoute=function onPlanRoute(){
return this._planRouteCommand.execute();
};PersonalScheduleController.prototype.


_onPlanRoute=function(){var ref=_asyncToGenerator(function*(){var _this4=this;
let statusInfo=yield this._socketService.sendAndWaitForResponse('GetLastKnownStatus',{
personId:this._personId,
includeGeocodeDetails:!0});


let modalInstance=this._$modal.open({
templateUrl:'/templates/features/personalSchedule/modals/scenarioSetupModalView',
controller:'ScenarioSetupModalController as controller',
resolve:{
personId:function(){return _this4._personId},
originAddress:function(){return _this4._getFormattedAddressFromStatusInfo(statusInfo)}}});



modalInstance.result.then(function(routeScenarioResponse){
_this4._$state.go('fdc.features.scenario',{
personInfo:_this4._personInfo,
originalInputs:routeScenarioResponse.originalInputs,
schedule:routeScenarioResponse.schedule,
route:routeScenarioResponse.route,
queryInterval:routeScenarioResponse.queryInterval,
fatigueThreshold:_this4._fatigueThreshold});

});
});function _onPlanRoute(){return ref.apply(this,arguments)}return _onPlanRoute}();PersonalScheduleController.prototype.

_getFormattedAddressFromStatusInfo=function _getFormattedAddressFromStatusInfo(statusInfo){
if(!_.exists(statusInfo.geocodeDetails)){
if(!_.exists(statusInfo.location)){
return'';
}

if(_.exists(statusInfo.location.description)&&statusInfo.location.description!==''){
return statusInfo.location.description;
}

return`${statusInfo.location.lat}, ${statusInfo.location.long}`;
}

let{
streetNumber:streetNumber,
streetName:streetName,
city:city,
stateCode:stateCode,
zipcode:zipcode}=
statusInfo.geocodeDetails;

return`${streetNumber} ${streetName}, ${city}, ${stateCode} ${zipcode}`;
};PersonalScheduleController.prototype.

groupFormatter=function groupFormatter(group){
return group.name;
};PersonalScheduleController.prototype.

weekFormatter=function weekFormatter(weekInterval){
let weekStartString=moment(weekInterval.start).tz(this.timezone).format('MMM DD');
let weekEndString=moment(weekInterval.end-1).tz(this.timezone).format('MMM DD, YYYY');

return`${weekStartString} – ${weekEndString}`;
};PersonalScheduleController.prototype.

_safeThresholdStatusGetter=function _safeThresholdStatusGetter(propertyName){
let fatigue=_.get(this,`personalStatistics.${propertyName}`);

return this._personalScheduleDataService.getThresholdStatus(fatigue,this.fatigueThreshold);
};_createClass(PersonalScheduleController,[{key:'selectedWeek',get:function()

{
return this._selectedWeek;
},set:function(

selectedWeek){
this._selectedWeek=selectedWeek;
}},{key:'tripFormatter',get:function()

{
if(!_.exists(this._tripFormatter)&&_.exists(this._use24HourTimeline)){
this._tripFormatter=this._use24HourTimeline?Formatters.tripLabel_24Hour():Formatters.tripLabel();
}
return this._tripFormatter;
}},{key:'dutyFormatter',get:function()

{
if(!_.exists(this._dutyFormatter)&&_.exists(this.timezone)&&_.exists(this._use24HourTimeline)){
this._dutyFormatter=Formatters.dutyLabelWithDefaultTimeZone(this.timezone,this._use24HourTimeline);
}
return this._dutyFormatter;
}},{key:'sleepFormatter',get:function()

{
if(!_.exists(this._sleepFormatter)&&_.exists(this.timezone)&&_.exists(this._use24HourTimeline)){
this._sleepFormatter=Formatters.sleepLabelWithDefaultTimeZone(this.timezone,this._use24HourTimeline);
}
return this._sleepFormatter;
}},{key:'sleepPromotingFormatter',get:function()

{
if(!_.exists(this._sleepPromotingFormatter)&&_.exists(this.timezone)&&_.exists(this._use24HourTimeline)){
this._sleepPromotingFormatter=Formatters.sleepLabelWithDefaultTimeZone(this.timezone,this._use24HourTimeline,'Sleeper Berth');
}
return this._sleepPromotingFormatter;
}},{key:'showLoadingSpinner',get:function()

{
return this.hideEverything||this._isLoadingDifferentWeek||!_.exists(this._timezone);
}},{key:'timezoneDescription',get:function()

{
return this.homeTimezone===this.timezone?_.get(this,'_personInfo.initialLocation.description'):this.timezone;
}},{key:'homeTimezone',get:function()

{
return _.get(this,'_personInfo.homeTimezone');
}},{key:'timezone',get:function()

{
return this._timezone;
}},{key:'displayTimeZone',get:function()

{
return this._displayTimeZone;
}},{key:'availableWeeks',get:function()

{
return this._availableWeeks;
}},{key:'personInfo',get:function()

{
return this._personInfo;
}},{key:'personalSchedule',get:function()

{
return this._personalSchedule;
}},{key:'fatigueThreshold',get:function()

{
return this._fatigueThreshold;
}},{key:'deviationThreshold',get:function()

{
return this._deviationThreshold;
}},{key:'groupMemberships',get:function()

{
return this._groupMemberships;
}},{key:'timeOfLastScheduleUpdate',get:function()

{
return this._timeOfLastScheduleUpdate;
}},{key:'now',get:function()

{
return this._now;
}},{key:'invalidDataWarning',get:function()

{
return this._invalidDataWarning;
}},{key:'timeOfLastHosStatus',get:function()

{
return this._timeOfLastHosStatus;
}},{key:'predictedWorkday',get:function()

{
return this._predictedWorkday;
}},{key:'forecastDutyInterval',get:function()

{
return this._forecastDutyInterval;
}},{key:'estimatesAsOfTime',get:function()

{
return this._estimatesAsOfTime;
}},{key:'dailySchedules',get:function()

{
return this._dailySchedules;
}},{key:'personalStatistics',get:function()

{
return this._personalStatistics;
}},{key:'peakThresholdStatus',get:function()

{
return this._safeThresholdStatusGetter('maxFatigueOnDuty');
}},{key:'averageThresholdStatus',get:function()

{
return this._safeThresholdStatusGetter('averageFatigueOnDuty');
}}]);return PersonalScheduleController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_startLoading',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_startLoading'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_startLoadingDataForSelectedWeek',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_startLoadingDataForSelectedWeek'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onPlanRoute',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onPlanRoute'),_class.prototype)),_class);


module.exports=PersonalScheduleController;
//# sourceMappingURL=personalScheduleController.js.map
